export const formatDate = (dateInput: string | number | Date | undefined | null): string => {
    if (!dateInput) return '-';
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('en-IN', { 
        timeZone: 'Asia/Kolkata', 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric' 
    }).replace(/\//g, '-');
};

export const formatTime = (dateInput: string | number | Date | undefined | null): string => {
    if (!dateInput) return '-';
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return '-';

    return date.toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const formatDateTime = (dateInput: string | number | Date | undefined | null): string => {
    if (!dateInput) return '-';
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return '-';

    const dateStr = formatDate(date);
    const timeStr = formatTime(date);
    return `${dateStr} ${timeStr}`;
};
